<template>
  <div class="field">
    <span v-if="label"><strong>{{ label }}: </strong></span>
    <div class="p-inputgroup" :class="{ 'mt-2': label }">
      <Dropdown
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :options="grupos"
        optionLabel="nombre"
        dataKey="id"
        :filter="true"
        :placeholder="placeholder"
        :loading="cargando"
      >
        <template #option="slotProps">
          <div class="p-dropdown-car-option">
            <span>{{ slotProps.option.nombre }} </span>
          </div>
        </template>
      </Dropdown>
      
      <Button
        v-if="permitirCrear"
        class="p-button-info"
        icon="pi pi-plus"
        @click="abrirModalGrupo"
        v-tooltip.top="'Crear Nuevo Grupo'"
      />
    </div>

    <!-- Modal Integrado para Crear Grupo -->
    <GrupoCreate 
      :show="mostrarModalGrupo" 
      :grupo="grupoParaModal"
      @closeModal="cerrarModalGrupo" 
      @actualizarListado="alCrearGrupo"
    />
  </div>
</template>

<script>
import GrupoService from "@/service/GrupoService";
import { useAuth } from "@/stores";
import GrupoCreate from "@/module/grupos/GrupoCreate.vue";

export default {
  name: 'ZapiGrupoDropdown',
  components: { GrupoCreate },
  props: {
    label: { type: String, default: 'GRUPO' },
    modelValue: { type: [Object, String, Number], default: null },
    placeholder: { type: String, default: 'Seleccione un grupo' },
  },
  emits: ['update:modelValue', 'onAdd'],
  data() {
    return {
      grupos: [],
      cargando: false,
      auth: null,
      grupoService: null,
      mostrarModalGrupo: false,
      grupoParaModal: {}
    }
  },
  computed: {
    permitirCrear() {
      if (!this.auth || !this.auth.user || !this.auth.user.permissions) return false;
      return 'Grupo Crear' in this.auth.user.permissions;
    }
  },
  created() {
    this.grupoService = new GrupoService();
    this.auth = useAuth();
  },
  mounted() {
    this.cargarGrupos();
  },
  methods: {
    cargarGrupos() {
      this.cargando = true;
      this.grupoService.getGrupoAll().then(response => {
        const rawGrupos = response.grupos ? response.grupos : (response.data ? response.data : response);
        this.grupos = Array.isArray(rawGrupos) ? rawGrupos.filter(g => g.estado != 0 && g.nombre !== 'NO DEFINIDO') : [];
      }).catch(err => {
        console.error("Error al cargar grupos:", err);
      }).finally(() => {
        this.cargando = false;
      });
    },
    // Este método se puede llamar desde el padre usando $refs para forzar recarga
    recargar() {
      this.cargarGrupos();
    },
    abrirModalGrupo() {
      this.grupoParaModal = {
        estado: { label: "ACTIVO", value: 1 },
      };
      this.mostrarModalGrupo = true;
    },
    cerrarModalGrupo() {
      this.mostrarModalGrupo = false;
    },
    alCrearGrupo() {
      // Recargar grupos cuando se crea uno nuevo
      this.cargarGrupos();
      // El GrupoCreate emite closeModal internamente pero por si acaso
      this.cerrarModalGrupo();
    }
  }
}
</script>
